import { render, staticRenderFns } from "./RequestCreditsModal.vue?vue&type=template&id=6f8d6e26&scoped=true&"
import script from "./RequestCreditsModal.vue?vue&type=script&lang=js&"
export * from "./RequestCreditsModal.vue?vue&type=script&lang=js&"
import style0 from "./RequestCreditsModal.vue?vue&type=style&index=0&id=6f8d6e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d6e26",
  null
  
)

export default component.exports